import { render } from "./AllcardsSection.vue?vue&type=template&id=767b7421&scoped=true"
import script from "./AllcardsSection.vue?vue&type=script&lang=js"
export * from "./AllcardsSection.vue?vue&type=script&lang=js"

import "./AllcardsSection.vue?vue&type=style&index=0&id=767b7421&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767b7421"]])

export default __exports__